import * as React from 'react';
import { default as Grid, GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
const Title = (props) => {
    const { title, gutter = 'default', iconSize = 'sm' } = props;
    return (React.createElement(Grid, { noWrap: true, align: ['middle-xs'], gutter: gutter },
        React.createElement(GridColumn, { width: ['min'] },
            React.createElement(Icon, { modifiers: "#compare", size: iconSize, align: "none" })),
        React.createElement(GridColumn, { width: ['max'] },
            React.createElement(Heading, { element: "h1", className: "h3" }, title))));
};
export default Title;
